import { Injectable } from '@angular/core';
import { BaseApiService } from '../../base-api.service';
import { FamilyCertificate, ProductFamily } from 'src/app/models/product-families/product-family.model';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';
import { AuthService } from '../../authentication/auth.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RestProductFamiliesService extends BaseApiService {
  
  
  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
      super(httpClient, translate);}
      
      createProductFamily(productFamily: ProductFamily): Observable<ProductFamily> {
        return this.httpClient.post<ProductFamily>(super.getUpsApiHost() + "DeviceTypeFamilies", productFamily, {headers : this.authService.upsHttpHeaders});
      }
      
      updateProductFamily(productFamily: ProductFamily): Observable<ProductFamily> {
        return this.httpClient.put<ProductFamily>(super.getUpsApiHost() + "DeviceTypeFamilies/" + productFamily.id, productFamily, {headers : this.authService.upsHttpHeaders});
      }
      
      deleteProductFamily(id: number): Observable<any> {
        return this.httpClient.delete<any>(super.getUpsApiHost() + "DeviceTypeFamilies/" + id, {headers : this.authService.upsHttpHeaders});
      }
      
      getProductFamilyById(id: number) : Observable<ProductFamily> {
        return this.httpClient.get<ProductFamily>(super.getUpsApiHost() + "DeviceTypeFamilies/" + id, { headers: this.authService.upsHttpHeaders });
      }

      getAllProductFamilies() : Observable<ProductFamily[]>{
        return this.httpClient.get<ProductFamily[]>(super.getUpsApiHost() + "DeviceTypeFamilies", {headers : this.authService.upsHttpHeaders});
      }
      
      getAllProductFamiliesCertificates(): Observable<FamilyCertificate[]> {
        return this.httpClient.get<FamilyCertificate[]>(super.getUpsApiHost() + "Documents/FamilyCertificates", {headers : this.authService.upsHttpHeaders});
      }
      
      uploadFamilyCertificate(file: File): Observable<FamilyCertificate> {
        const formData: FormData = new FormData();
        formData.append('File', file, file.name);
        return this.httpClient.post<FamilyCertificate>(super.getUpsApiHost() + "Documents/FamilyCertificates", formData, {headers : this.authService.upsHttpHeaders});
      }

      deleteFamilyCertificate(certificateId: number): Observable<any> {
        return this.httpClient.delete<any>(super.getUpsApiHost() + "Documents/FamilyCertificates/" + certificateId, {headers : this.authService.upsHttpHeaders});
      }
    }
    